import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { IVKKontraktLeverantor } from "../../dto/kontrakt/kontrakt-betalningar-dto";

export class UpdateVirkeskopskontraktLeverantorCommand extends BasicCommand<UpdateVirkeskopskontraktLeverantorCommand> {
    readonly kontraktGuid: string;
    readonly leverantorGuid: string;
    readonly forskott: boolean;
    readonly betalplan?: boolean;
    readonly makeGodkannandeKravsEj?: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateVirkeskopskontraktLeverantorCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "KontraktBetalningar";

    get primaryKey(): IVirkeskopskontraktLeverantorPrimaryKey {
        return {
            kontraktGuid: this.kontraktGuid,
            leverantorGuid: this.leverantorGuid
        };
    }

    constructor(kontraktLeverantor: IVKKontraktLeverantor) {
        super(UpdateVirkeskopskontraktLeverantorCommand.$type, UpdateVirkeskopskontraktLeverantorCommand.$groupKey, CommandType.Replace);
        this.kontraktGuid = kontraktLeverantor.kontraktGuid;
        this.leverantorGuid = kontraktLeverantor.leverantorGuid;
        this.forskott = kontraktLeverantor.forskott;
        this.makeGodkannandeKravsEj = kontraktLeverantor.makeGodkannandeKravsEj;
        this.betalplan = kontraktLeverantor.betalplan;
    }
}

export interface IVirkeskopskontraktLeverantorPrimaryKey extends IPrimaryKey<IVirkeskopskontraktLeverantorPrimaryKey>{
    kontraktGuid: string;
    leverantorGuid: string;
}
